import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Home, Search, ArrowLeft } from 'lucide-react';
import Header from '../landing/Header';
import Footer from '../landing/Footer';

const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found | BuildPilot App</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="The page you are looking for does not exist." />
      </Helmet>
      
      <div className="min-h-screen flex flex-col">
        <Header />
        
        <main className="flex-grow flex items-center justify-center px-4 py-16 bg-gradient-to-b from-purple-50 to-white">
          <div className="text-center max-w-lg">
            <div className="mb-8">
              <span className="text-8xl font-bold bg-gradient-to-r from-purple-600 to-pink-500 bg-clip-text text-transparent">
                404
              </span>
            </div>
            
            <h1 className="text-3xl font-bold text-gray-900 mb-4">
              Page Not Found
            </h1>
            
            <p className="text-lg text-gray-600 mb-8">
              Sorry, we could not find the page you are looking for. It might have been moved or does not exist.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-gradient-to-r from-purple-600 to-pink-500 text-white font-semibold rounded-full hover:opacity-90 transition-opacity"
                data-testid="404-home-btn"
              >
                <Home className="w-5 h-5" />
                Go Home
              </a>
              
              <a
                href="/building-in-adelaide"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 border-2 border-purple-600 text-purple-600 font-semibold rounded-full hover:bg-purple-50 transition-colors"
                data-testid="404-explore-btn"
              >
                <Search className="w-5 h-5" />
                Explore Suburbs
              </a>
            </div>
            
            <div className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-500 mb-4">Looking for something specific?</p>
              <div className="flex flex-wrap justify-center gap-3 text-sm">
                <a href="/building-in-adelaide" className="text-purple-600 hover:underline">Adelaide</a>
                <span className="text-gray-300">|</span>
                <a href="/building-in-melbourne" className="text-purple-600 hover:underline">Melbourne</a>
                <span className="text-gray-300">|</span>
                <a href="/building-in-sydney" className="text-purple-600 hover:underline">Sydney</a>
                <span className="text-gray-300">|</span>
                <a href="/building-in-brisbane" className="text-purple-600 hover:underline">Brisbane</a>
                <span className="text-gray-300">|</span>
                <a href="/building-in-perth" className="text-purple-600 hover:underline">Perth</a>
              </div>
            </div>
          </div>
        </main>
        
        <Footer />
      </div>
    </>
  );
};

export default NotFound;
